module.exports = __webpack_public_path__ + "static/media/img172.acb6f0ee.jpg";